define('views/shop/instore/terms',[
    'backbone',
    'views/_base/baseview',
    'text!views/shop/instore/terms.html'
], function(Backbone, BaseView, Template){
    'use strict';

    return BaseView.extend({
        className : 'ecard-terms-container',
        tagName   : 'div',
        isRender  : true,
        needsAuth : false,
        template  : _.template(Template),
        events    : {
            'click .js-ecard-terms-button': 'closeMODAL',
            'click #pf-modal-close-btn'   : 'closeMODAL'
        },
        initialize: function(options){
            var options = options || {};

            this.terms = options.terms;
            
            this.elementName = options.elementName;
            
            BaseView.prototype.initialize(this);
        },

        render: function(){
            var that = this;

            this.$el.html(this.template());

            setTimeout(function(){
                $('.js-ecard-terms-button').on('click', that.closeMODAL);
                $('#pf-modal-close-btn').on('click', that.closeMODAL);
            });

            return this;
        },

        closeMODAL: function(){
            $('#pf-modal-modern').fadeOut(function(){
                $('#pf-modal-modern').remove();
            });
        },

        close: function(){}
    });
});

